// src/utils/AuthStorage.js

export const AUTH_SESSION_CHANGED_EVENT = 'infomaio:auth-session-changed';
export const AUTH_SESSION_EXPIRED_EVENT = 'infomaio:auth-session-expired';

const AUTH_STORAGE_KEYS = [
  'token',
  'tokenExpires',
  'tokenGeradoAs',
  'refreshToken',
  'refreshTokenExpires',
  'usuarioId',
  'usuarioNome',
  'userLogin2',
];

const notify = (eventName) => {
  window.dispatchEvent(new Event(eventName));
};

export const getAuthSession = () => ({
  token: localStorage.getItem('token'),
  tokenExpires: localStorage.getItem('tokenExpires'),
  refreshToken: localStorage.getItem('refreshToken'),
  refreshTokenExpires: localStorage.getItem('refreshTokenExpires'),
});

export const saveAuthTokens = (token) => {
  if (!token?.accessToken || !token?.expiresIn) {
    throw new Error('A API não retornou um token de acesso válido');
  }

  localStorage.setItem('token', token.accessToken);
  localStorage.setItem('tokenExpires', new Date(token.expiresIn).toISOString());

  if (token.refreshToken && token.refreshTokenExpiresIn) {
    localStorage.setItem('refreshToken', token.refreshToken);
    localStorage.setItem('refreshTokenExpires', new Date(token.refreshTokenExpiresIn).toISOString());
  } else {
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('refreshTokenExpires');
  }

  // Mantido por compatibilidade com os pontos que consultam o horário de geração.
  localStorage.setItem('tokenGeradoAs', new Date().toISOString());
  notify(AUTH_SESSION_CHANGED_EVENT);
};

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
  notify(AUTH_SESSION_CHANGED_EVENT);
};

export const notifyAuthSessionExpired = () => {
  notify(AUTH_SESSION_EXPIRED_EVENT);
};

export default clearAuthStorage;
